export enum ReferenceNumberBookingType {
  Release = 'release',
  VendorRelease = 'vendor_release',
}
